<template>
  <div class="custom-spinner" :style="{ width: size, height: size }">
    <svg :width="size" :height="size" viewBox="0 0 50 50">
      <circle 
        class="spinner-path" 
        cx="25" cy="25" 
        r="20" 
        fill="none" 
        :stroke="color" 
        :stroke-width="strokeWidth" 
        stroke-linecap="round"
      />
    </svg>
  </div>
</template>

<script>
export default {
  name: 'Spinner',
  props: {
    color: { type: String, default: '#F36600 ' }, // Цвет спиннера
    size: { type: String, default: '40px' }, // Размер спиннера
    strokeWidth: { type: String, default: '4' } // Толщина линии
  }
};
</script>

<style scoped>
.custom-spinner {
  display: flex;
  justify-content: center;
  align-items: center;
}

.spinner-path {
  stroke-dasharray: 125.6;
  stroke-dashoffset: 0;
  transform-origin: center;
  animation: spin 1s linear infinite, dash 1.5s ease-in-out infinite;
}

@keyframes spin {
  100% {
    transform: rotate(360deg);
  }
}

@keyframes dash {
  0% {
    stroke-dashoffset: 125.6;
  }
  50% {
    stroke-dashoffset: 62.8;
  }
  100% {
    stroke-dashoffset: 125.6;
  }
}
</style>